var codeExecuted = false;

function calculateAndDisplayDiscount(
  priceElement,
  discountAmount,
  discountType
) {
  var priceString = priceElement.textContent.trim().replace("$", "");
  var price = parseFloat(priceString);

  var discountedPrice =
    discountType === "percentage"
      ? Math.round(price * (1 - discountAmount / 100))
      : Math.round(price - discountAmount);
  priceElement.textContent = "$" + discountedPrice + " USD";
}

function executeCodeOnce() {
  var discountAmountFromCMC =
    document.querySelector("#discount-amount").textContent;
  
  var discountAmountFromCMCSecond =
    document.querySelector("#discount-amount-two").textContent;

  
  var discountPercentsFromCMC =
    document.querySelector("#discount-percents").textContent;

  var discountPercentsFromCMCTwo =
    document.querySelector("#discount-percents-two").textContent;


  if (!codeExecuted) {
    var priceElement = document.querySelectorAll("#final-price .money");

    var priceElementAmountTwo = document.querySelectorAll("#final-price-two .money");

    var priceElementPercents = document.querySelectorAll(
      "#final-price-precents-desktop .money"
    );

    var priceElementPercentsTwo = document.querySelectorAll(
      "#final-price-precents-desktop-two .money"
    );

    if (priceElement) {
      priceElement.forEach((price) => {
        calculateAndDisplayDiscount(price, discountAmountFromCMC, "amount");
      });
    }

        if (priceElementAmountTwo) {
      priceElementAmountTwo.forEach((price) => {
        calculateAndDisplayDiscount(price, discountAmountFromCMCSecond, "amount");
      });
    }

    if (priceElementPercents) {
      priceElementPercents.forEach((price) => {
        calculateAndDisplayDiscount(
          price,
          discountPercentsFromCMC,
          "percentage"
        );
      });
    }

        if (priceElementPercentsTwo) {
      priceElementPercentsTwo.forEach((price) => {
        calculateAndDisplayDiscount(
          price,
          discountPercentsFromCMCTwo,
          "percentage"
        );
      });
    }

    codeExecuted = true;
  }
}

document.addEventListener("DOMContentLoaded", executeCodeOnce);
